/**
 * Search if keystring is included in keys of provided map
 * @param {MutableRefObject<Map<string, any>>} refs Map to be searched
 * @param {string} keyString string to be serched in map keys
 * @return {MutableRefObject[]} value of Maps with matched key can be provided to TweenMax animations
 */
export const searchRefs = (refs, keyString) => {
    return refs ? [...new Map([...refs.current].filter(([k, v]) => k.includes(keyString))).values()] : [];
};
//# sourceMappingURL=searchRefs.js.map